import React, { Component } from 'react';
import PropTypes from 'prop-types';

const LOCALES = {
    "search-input": {
        label: {
            fr: "Rechercher pour",
            en: "Search for"
        },
        button: {
            fr: "Rechercher",
            en: "Search"
        }
    }
}

export default class SearchInput extends Component {
    constructor(props) {
        super(props);

        this.input = null;

        this._searchHandler = this._searchHandler.bind(this);
        this._onChangeHandler = this._onChangeHandler.bind(this);
        
        this.state = {
            value: ""
        };
    }

    componentDidUpdate(prevProps,prevState) {
        if (this.props.format !== prevProps.format)
        {
            this.setState({value: ""},() => this.input.focus());
        }
    }

    render()
    {
        //let inputName = `search-${this.props.format}`;
        return (
            <div className="form-group">
                <label htmlFor="search" className="col-sm-3 control-label">
                    <span className="field-name">{LOCALES["search-input"].label[this.props.lang]}</span>
                </label>
                <div className="col-sm-9">
                    <div className="input-group">
                        <input id="search" name="search" type="text" size="20" maxLength="40" value={this.state.value} onChange={this._onChangeHandler} onKeyDown={this._onKeyDownHandler.bind(this)} className="form-control" ref={el => this.input = el} />
                        <span className="input-group-btn">
                            <input disabled={!this._canSearch()} name="submitButtonSearchCodes" type="button" className="btn btn-primary" value={LOCALES["search-input"].button[this.props.lang]} onClick={this._searchHandler} />
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        if (this.props.focusOnInit)
        {
            this.input.focus();
        }
    }

    _canSearch() {
        return (this.state.value.toString().trim().length > 0?true:false);
    }

    _onChangeHandler(e) {
        this.setState({value: e.target.value});
    }

    _onKeyDownHandler(e) {
        if (e.key === "Enter")
        {
            e.preventDefault();
            this._searchHandler(e);
        }
        //Si c'est une touche alpha tappé dans un champ numérique, on empêche de l'écrire
        else if ((e.key.length === 1) && (this.props.format === "number") && (!RegExp(/[0-9]|-/).test(e.key)))
        {
            e.preventDefault();
        }
    }

    _searchHandler(e) {
        e.preventDefault();
        if (this._canSearch())
        {
            this.setState({value: this._cleanValue(this.state.value)},() => {
                if (this.props.onSearch)
                {
                    this.props.onSearch(this.state.value);
                }
            });
        }
    }

    _cleanValue(val) {
        let newVal = val;
        //Enleve les espaces debut et fin
        newVal = newVal.trim();

        //Remplace 2 espaces ou plus par 1
        newVal = newVal.replace(/\s\s+/g, ' ');

        return newVal;
    }
}

SearchInput.defaultProps = {
    format: "text"
};

SearchInput.propTypes = {
    lang: PropTypes.string.isRequired,
    onSearch: PropTypes.func.isRequired,
    format: PropTypes.oneOf(["text","number"]).isRequired,
    focusOnInit: PropTypes.bool
}